import exclusiveMitraItemsApi from 'shared_js/api/exclusiveApi/exclusiveMitraItemsApi';
import logger from 'shared_js/modules/logger/logger';
import apiAgent from 'shared_js/api/publicApi/publicAgentApi';

import { LOADING, LOADED, ERROR } from 'shared_js/constants/commonStatuses';
import {
  SET_LOADING_STATUS,
  SET_MITRA_ITEMS,
  SET_MITRA_ITEM_TRANSACTION,
} from './mutationTypes';

async function groupMitraItemTransaction(transactions) {
  try {
    return transactions.reduce((acc, transaction) => {
      const mitraItemId = transaction.mitra_item_id;

      // If we haven't seen this mitra_item_id yet, or if this transaction has a higher id
      if (!acc[mitraItemId] || transaction.id > acc[mitraItemId].id) {
        acc[mitraItemId] = transaction;
      }

      return acc;
    }, {});
  } catch (e) {
    return {};
  }
}

async function retrieveMitraItemTransactions() {
  try {
    return await exclusiveMitraItemsApi.retrieveMitraItemTransactions();
  } catch (e) {
    return {};
  }
}

export default {
  async retrieveMitraItems({ state, commit }) {
    if (state.mitraItems.length) return;
    commit('SET_LOADING_STATUS', LOADING);
    try {
      const { data } = await exclusiveMitraItemsApi.retrieveMitraItems();
      const filteredItems = data.filter(item => item.status !== 'disabled');
      commit(SET_MITRA_ITEMS, filteredItems);

      const itemIds = filteredItems.map(item => item.id);
      const transactions = await retrieveMitraItemTransactions();

      const mitraItemTransactions = await groupMitraItemTransaction(
        transactions.data,
      );

      itemIds.forEach(mitraItemId => {
        if (!mitraItemTransactions[mitraItemId]) return;
        commit(SET_MITRA_ITEM_TRANSACTION, {
          mitraItemId,
          transaction: mitraItemTransactions[mitraItemId],
        });
      });
      commit(SET_LOADING_STATUS, LOADED);
    } catch (e) {
      logger.log(e);
      commit(SET_LOADING_STATUS, ERROR);
    }
  },
  async retrieveMitraItemById({ state, dispatch }, { id }) {
    try {
      await dispatch('retrieveMitraItems');
      const item = state.mitraItems.find(obj => obj.id === id);
      return item;
    } catch (e) {
      logger.log(e);
      return undefined;
    }
  },
  async retrieveUserAgentProfile() {
    try {
      const { data } = await apiAgent.retrieveUserAgentProfile();
      return data;
    } catch (e) {
      logger.log(e);
      return undefined;
    }
  },
  async retrieveMitraItemTransactionById({ dispatch }, { id }) {
    try {
      const response = await exclusiveMitraItemsApi.retrieveMitraItemTransaction(
        id,
      );
      const item = await dispatch('retrieveMitraItemById', {
        id: response.data.mitra_item_id,
      });
      if (!item) return undefined;
      return {
        ...item,
        transaction: response.data,
      };
    } catch (e) {
      logger.log(e);
      return undefined;
    }
  },
  updateMitraItemTransaction({ state, commit }, { mitraItemId, transaction }) {
    if (!state.mitraItems.length) return;
    commit(SET_MITRA_ITEM_TRANSACTION, { mitraItemId, transaction });
  },
};
